import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';

class ExitButton extends React.Component{
    constructor() {
        super();
        this.state={
        }
    }
    render() {
        const {data} = this.props
        return (
            <Grid item sm={12} alignItems={"center"} justify={'center'} className='exit-button' container>
                <img className={'exit-button-image'} src={data.image} alt=""/>
                <p className={'exit-button-text'}>{data.text}</p>
            </Grid>
            )
    }

}
export default ExitButton